import React from 'react';
import { Snackbar } from '@spotify-internal/encore-web';
import { buildRemoveSnackbarAction } from './actions';
import { useSnackbarNotifications } from './SnackbarNotifications';

// Ensures only one snackbar is displayed at a time
// The animation entrance and exit of Snackbar is triggered by its mounting and unmounting
// The `key` prop exists to ensure re-mounting occurs when the snackbar message changes

export const SnackbarQueue: React.FunctionComponent<{}> = () => {
  const [state, dispatch] = useSnackbarNotifications();
  const firstSnackbar = state.snackbars[0];

  const onExited = () => dispatch(buildRemoveSnackbarAction(firstSnackbar?.id));

  return firstSnackbar ? (
    <Snackbar
      colorSet={firstSnackbar.colorSet || 'base'}
      className="encore-creator-dark-theme encore-layout-themes"
      data-hotjar-trigger="snackbar"
      key={firstSnackbar.id}
      onExited={onExited}
    >
      {firstSnackbar.message}
    </Snackbar>
  ) : null;
};
